"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTENT_UPLOAD_SLI_ERROR_PREFIX = void 0;
var CONTENT_UPLOAD_SLI_ERROR_PREFIX = exports.CONTENT_UPLOAD_SLI_ERROR_PREFIX = 'content upload failed: ';